var exports = {
  "DR": "Box_0__PwcOfU",
  "wy": "Box_1__kRaEe0",
  "pv": "Box_2__nSQw4M",
  "w9": "Box_3__K1vlF-",
  "pQ": "Box_4__iIlWGd",
  "N2": "Text_0__jRWalS",
};

module.exports = exports;
